import React from "react";
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from "@/components/ui/card";
import { ChartContainer } from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";

interface VideoTimelineData {
  name: string;
  videos: number;
}

interface VideoTrendChartProps {
  data: VideoTimelineData[];
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-2 border rounded shadow-md">
        <p className="text-sm font-medium text-center">{`${payload[0].payload.name}`}</p>
        <p className="text-sm">{`Videos: ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};

const EmptyState = () => (
  <div className="h-[250px] w-full flex items-center justify-center">
    <p className="text-muted-foreground">No video data available for this time range</p>
  </div>
);

const VideoTrendChart = ({ data }: VideoTrendChartProps) => {
  const hasData = data && data.length > 0 && data.some(item => item.videos > 0);

  return (
    <Card className="md:col-span-2">
      <CardHeader>
        <CardTitle>Video Creation Trend</CardTitle>
        <CardDescription>Videos created by day</CardDescription>
      </CardHeader>
      <CardContent>
        {!hasData ? (
          <EmptyState />
        ) : (
          <div className="h-[250px] w-full">
            <ChartContainer className="h-full" config={{}}>
              <BarChart data={data} margin={{ top: 10, right: 10, bottom: 20, left: 10 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="name" dy={10} />
                <YAxis width={30} />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey="videos" name="Videos" fill="#3b82f6" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ChartContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default VideoTrendChart;
